// import Config from '../../Config';
import Config from "../../app-config";
import axios from "axios";
import { logEvent } from "@adaptis/flow-components";

export function knoseAPI(action, params, method = "POST") {
  return new Promise(async function (resolve, reject) {
    let options = {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    if (params && params["captcha"] !== undefined) {
      options.headers["x-recaptcha"] = params["captcha"];
      delete params["captcha"];
    }

    if (method !== "GET") {
      options.body = JSON.stringify(params);
    }

    try {
      var response = await fetch(Config.knose_portal_api_url + action, options);
      let data = await response.json();
      return resolve(data);
    } catch (e) {
      console.log("e :>> ", e);
      // logEvent('error', true, 'knoseAPI() error', e);
      logEvent("error", true, "knoseAPI() error", {
        error: e,
        action: action,
        params: params,
      });
      return reject("Error");
    }
  });
}

const encodeFormData = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export function paywayAPI(action, params, method = "POST") {
  return new Promise(async function (resolve, reject) {
    var authOptions = {
      method: "POST",
      url: Config.payway_api_url + action,
      data: encodeFormData(params),
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Basic " + window.btoa(Config.payway_api_key),
        "Content-Type": "application/x-www-form-urlencoded",
      },
      mode: "no-cors",
      json: true,
    };

    try {
      let response = await axios(authOptions);
      let data = await response.json();
      return resolve(data);
    } catch (e) {
      return reject("Error");
    }
  });
}

export function middlemanAPI(action, params, method = "POST") {
  return new Promise(async function (resolve, reject) {
    let options = {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    // if (params && params["captcha"] !== undefined) {
    //   options.headers["x-recaptcha"] = params["captcha"];
    //   delete params["captcha"];
    // }
    
    if (Config.middleman_api_key) {
      options.headers["x-api-key"] = Config.middleman_api_key;
    }

    if (method !== "GET") {
      options.body = JSON.stringify(params);
    }

    try {
      // console.log("vao day 00000");
      var response = await fetch(Config.middleman_api_url + action, options);
      // console.log("vao day 111111", response);
      let data = await response.json();
      // console.log("vao day 2222222 1", response);
      return resolve(data);
    } catch (e) {
      // console.log("vao day 2222 e :>> ", e);
      // logEvent('error', true, 'knoseAPI() error', e);
      logEvent("error", true, "middlemanAPI() error", {
        error: e,
        action: action,
        params: params,
      });
      return reject("Error");
    }
  });
}